// Libraries
import { combineReducers } from 'redux';

// Reducers
import authentication from '~/redux/reducers/authentication-reducer';
import challenges from '~/redux/reducers/challenges-reducer';
import general from '~/redux/reducers/general-reducer';
import modal from '~/redux/reducers/modal-reducer';

// Combine Reducers
const rootReducer = combineReducers({
	authentication,
	challenges,
	general,
	modal,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.jsx